var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-sheet',{staticClass:"fill-height",attrs:{"color":"primary","dark":""}},[_c('v-container',{staticClass:"fill-height justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }